'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';

var getJobYouWillLove = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, query = _a.query, smartNaviVersion = _a.smartNaviVersion, formDataExcludeJobIds = _a.formDataExcludeJobIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var encodeQuery, urlApi, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    encodeQuery = query
                        ? "?".concat(new URLSearchParams(__assign(__assign({}, query), { t: String(Date.now()) })).toString(), "&").concat(new URLSearchParams(formDataExcludeJobIds).toString())
                        : '';
                    urlApi = "".concat(baseUrl, "/smartnavi/").concat(smartNaviVersion, "/jobs").concat(encodeQuery);
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'GET',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'Content-Type': 'application/json'
                            }
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.total) > 0) {
                        return [2 /*return*/, {
                                data: res,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: {
                                    jobs: [],
                                    source: ''
                                },
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var STATUS_CODE = 200;
var getSpecialJob = function (_a) {
    var baseUrl = _a.baseUrl, accessToken = _a.accessToken, jobs = _a.jobs;
    return __awaiter(void 0, void 0, void 0, function () {
        var emptySpecialJob, urlApi, ids, res;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    emptySpecialJob = jobs.map(function (item) {
                        return __assign(__assign({}, item), { isSaved: false, isApplied: false, isBlackList: false, isMatching: false, redirectTo: '' });
                    });
                    if (!accessToken) {
                        return [2 /*return*/, {
                                data: emptySpecialJob,
                                error: ''
                            }];
                    }
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/special-jobs");
                    ids = jobs.map(function (item) { return item.jobId; });
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            body: JSON.stringify({ jobId: ids })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _c.sent();
                    if (((_b = res === null || res === void 0 ? void 0 : res.status) === null || _b === void 0 ? void 0 : _b.code) === STATUS_CODE) {
                        return [2 /*return*/, {
                                data: jobs.map(function (item, idx) {
                                    var _a, _b, _c, _d, _e, _f, _g;
                                    return __assign(__assign({}, item), { isMatching: (_a = res.data[idx].attributes) === null || _a === void 0 ? void 0 : _a.matching, isSaved: (_b = res.data[idx].attributes) === null || _b === void 0 ? void 0 : _b.saved, isApplied: (_c = res.data[idx].attributes) === null || _c === void 0 ? void 0 : _c.applied, isBlackList: (_d = res.data[idx].attributes) === null || _d === void 0 ? void 0 : _d.userBlackList, redirectTo: (_e = res.data[idx].attributes) === null || _e === void 0 ? void 0 : _e.redirectTo, jobInvitation: (_g = (_f = res.data[idx].attributes) === null || _f === void 0 ? void 0 : _f.jobInvitation) !== null && _g !== void 0 ? _g : { jobInvitationId: 0, status: 0 } });
                                }),
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: emptySpecialJob,
                                error: res === null || res === void 0 ? void 0 : res.error
                            }];
                    }
            }
        });
    });
};
var trackImpression = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var baseMsUrl, langCode, body, url, rawResponse, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                baseMsUrl = params.baseMsUrl, langCode = params.langCode, body = params.body;
                url = "".concat(baseMsUrl, "/smartnavi/v1/tracking-impression");
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                rawResponse = _a.sent();
                return [4 /*yield*/, rawResponse.json()];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { getJobYouWillLove, getSpecialJob, trackImpression };
//# sourceMappingURL=services.js.map
